var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames, firstStringProperty } from '@shapeable/utils';
import { breakpoints, theme } from '@shapeable/theme';
import { useEntity } from '../hooks/use-entity';
var cls = classNames('outline-entity-bubble');
import { rgba } from 'polished';
export var OutlineEntityBubbleDefaultProps = {
  overlayOpacity: 0.7,
  showImage: true,
  showBorder: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    border-radius: 50%;\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    text-align: center;\n    justify-content: center;\n    display: flex;\n    font-weight: 500;\n    line-height: 1.0em;\n    flex-direction: column;\n    align-items: center;\n    background-size: cover;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n\n    ", "\n\n  "], ["\n    border-radius: 50%;\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    text-align: center;\n    justify-content: center;\n    display: flex;\n    font-weight: 500;\n    line-height: 1.0em;\n    flex-direction: column;\n    align-items: center;\n    background-size: cover;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n\n    ", "\n\n  "])), theme.UNIT(16), theme.UNIT(16), theme.COLOR('light'), function (_a) {
    var showBorder = _a.showBorder;
    return showBorder && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border: ", " solid ", ";\n      width: ", ";\n      height: ", ";\n    "], ["\n      border: ", " solid ", ";\n      width: ", ";\n      height: ", ";\n    "])), theme.UNIT(1), theme.COLOR('light'), theme.UNIT(14), theme.UNIT(14));
  }, function (_a) {
    var scale = _a.scale,
      numberSize = _a.numberSize;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      font-size: ", "em;\n    "], ["\n      font-size: ", "em;\n    "])), numberSize ? numberSize : scale * 1.5);
  }, function (_a) {
    var _backgroundImage = _a._backgroundImage,
      showImage = _a.showImage;
    return showImage && _backgroundImage && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background-image: url(", ");\n    "], ["\n      background-image: url(", ");\n    "])), _backgroundImage);
  }, function (_a) {
    var _backgroundColor = _a._backgroundColor,
      _backgroundImage = _a._backgroundImage;
    return _backgroundColor && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), _backgroundColor);
  }, function (_a) {
    var _backgroundColor = _a._backgroundColor,
      _backgroundImage = _a._backgroundImage,
      _overlayColor = _a._overlayColor,
      showImage = _a.showImage;
    return showImage && _backgroundColor && _backgroundImage && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      background-image: linear-gradient(", " 0%, ", " 100%), url(", ");\n    "], ["\n      background-image: linear-gradient(", " 0%, ", " 100%), url(", ");\n    "])), _overlayColor, _overlayColor, _backgroundImage);
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var OutlineEntityBubble = function (props) {
  var className = props.className,
    children = props.children,
    showBorder = props.showBorder,
    numberSize = props.numberSize;
  var entity = useEntity(props.entity);
  var outlineNumber = entity.outlineNumber,
    name = entity.name,
    openGraph = entity.openGraph,
    color = entity.color;
  var image = firstStringProperty(entity, ['openGraph.image.thumbnails.small.url', 'openGraph.image.thumbnails.full.url', 'openGraph.image.url', 'banner.thumbnail.url', 'banner.image.url']);
  var scale = (showBorder ? 0.8 : 1) * ((outlineNumber === null || outlineNumber === void 0 ? void 0 : outlineNumber.length) > 3 ? 0.75 : 1);
  if (!image && !outlineNumber) {
    return null;
  }
  var overlayColor = (color === null || color === void 0 ? void 0 : color.value) && rgba(color.value, props.overlayOpacity);
  return React.createElement(My.Container, {
    showBorder: showBorder,
    scale: scale,
    numberSize: numberSize,
    showImage: props.showImage,
    _overlayColor: overlayColor,
    _backgroundColor: color === null || color === void 0 ? void 0 : color.value,
    _backgroundImage: image,
    className: cls.name(className)
  }, outlineNumber);
};
OutlineEntityBubble.defaultProps = OutlineEntityBubbleDefaultProps;
OutlineEntityBubble.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;